import { convertIRateResponseToIRateData, IRateData, IRateResponse } from './IRate';

export interface IRateConfigurationResponse {
  minimum?: number;
  additionalMinimum: boolean;
  baseCalculator: IRateResponse;
  excessCalculator?: IRateResponse;
  multiplier?: number;
  derivedFrom?: any; // this object is a serialized Rates.
}

export interface IRateConfigurationData {
  minimum?: number;
  additionalMinimum: boolean;
  baseCalculator: IRateData;
  excessCalculator?: IRateData;
  multiplier?: number;
  derivedFrom?: any;
}

export const convertIRateConfigurationResponseToIRateConfigurationData = ({
  baseCalculator,
  excessCalculator,
  ...rest
}: IRateConfigurationResponse): IRateConfigurationData => ({
  baseCalculator: convertIRateResponseToIRateData(baseCalculator),
  excessCalculator: !!excessCalculator ? convertIRateResponseToIRateData(excessCalculator) : undefined,
  ...rest,
});
